import { render, staticRenderFns } from "./LtIndex.vue?vue&type=template&id=58dbb9ee"
import script from "./LtIndex.vue?vue&type=script&lang=js"
export * from "./LtIndex.vue?vue&type=script&lang=js"
import style0 from "./LtIndex.vue?vue&type=style&index=0&id=58dbb9ee&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58dbb9ee')) {
      api.createRecord('58dbb9ee', component.options)
    } else {
      api.reload('58dbb9ee', component.options)
    }
    module.hot.accept("./LtIndex.vue?vue&type=template&id=58dbb9ee", function () {
      api.rerender('58dbb9ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/resetPassword/LtIndex.vue"
export default component.exports